<template>
	<div class="row" align-y="top" align-x="between" :job="job" :index="index">
		<el-form label-position="left" label-width="160px">
			<el-form-item label="職業">
				{{jobData.job}}
			</el-form-item>

			<el-form-item v-if="showTeacherOptions" label="教職類別">
				{{teacherGradeTrans}}
			</el-form-item>

			<el-form-item label="單位地點">
				{{jobData.city}}{{jobData.district}}
			</el-form-item>

			<el-form-item label="單位名稱">
				{{jobData.department}}
			</el-form-item>

			<el-form-item label="職位">
				{{jobData.position}}
			</el-form-item>

			<el-form-item v-if="showTeacherOptions" label="科目名稱">
				{{jobData.teacherSubject}}
			</el-form-item>

			<el-form-item label="期間">
				<el-checkbox v-model="jobData.presentlyEmployed" @change="handleChecked">我現在在這裡工作</el-checkbox>
			</el-form-item>

			<el-form-item>
				<span>{{jobData.startTime | moment("YYYY / MM")}}</span>
				<span style="margin: 0 10px;">{{jobData.presentlyEmployed ? '至今' : '到'}}</span>
				<span v-if="!jobData.presentlyEmployed">{{jobData.endTime | moment("YYYY / MM")}}</span>
			</el-form-item>
		</el-form>
		<el-button @click="edit()" type="text">點選修改
			<i class="el-icon-arrow-right"></i>
		</el-button>
	</div>
</template>

<script>
export default {
	props: ["job", "index"],
	data() {
		return {
			checked: false,
			jobData: {}
		};
	},
	computed: {
		showTeacherOptions() {
			return this.job.type == "教育工作者";
		},
		teacherGradeTrans() {
			switch (this.jobData.teacherGrade) {
				case "elementary":
					return "國小";
					break;
				case "junior":
					return "國中";
					break;
				case "senior":
					return "高中";
					break;
				case "others":
					return "其他";
					break;
			}
			return "";
		}
	},
	methods: {
		edit() {
			console.log("resume edit", this.index);
			this.$emit("edit", this.index);
		},
		initJob() {
			this.jobData.job = this.job.type;
			this.jobData.teacherGrade = this.job.teacher_grade;
			this.jobData.city = this.job.city;
			this.jobData.district = this.job.district;
			this.jobData.department = this.job.department;
			this.jobData.position = this.job.position;
			this.jobData.teacherSubject = this.job.subject;
			this.jobData.presentlyEmployed = this.job.presently_employed;
			this.jobData.startTime = this.job.start_time;
			this.jobData.endTime = this.job.end_time;
		},
		handleChecked(value) {
			this.jobData.presentlyEmployed = !value;
		}
	},
	created() {
		this.initJob();
	}
};
</script>

<style lang="scss" scoped>
.el-form-item {
	margin-bottom: auto;
}
</style>
